/* global fetch, console */
/**
 * IP Geolocation utility to detect Spanish-speaking countries
 * Sets a cookie that can be read by server-side templates
 */

// Spanish-speaking country codes
const SPANISH_SPEAKING_COUNTRIES = ['MX'];

/**
 * Detects if user is from a Spanish-speaking country and sets cookie
 * Also updates the terms link dynamically if on first visit
 */
export function detectSpanishCountry() {
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      performDetection();
    });
  } else {
    // DOM is already ready
    performDetection();
  }
}

/**
 * Performs the actual detection
 */
async function performDetection() {
  // Check if cookie already exists
  if (getCookie('is_spanish_country')) {
    return;
  }

  const data = await fetchGeoData();

  if (!data || data?.status === 'fail') {
    console.error('IP geolocation API error:', data?.message || 'Unknown error');
    setCookie('is_spanish_country', 'false', 365);
    return;
  }

  const countryCode = data?.countryCode;
  const isSpanish = SPANISH_SPEAKING_COUNTRIES.includes(countryCode);

  setCookie('is_spanish_country', isSpanish ? 'true' : 'false', 365);

  // Update link dynamically if on first visit
  updateTermsLink(isSpanish);
}

async function fetchGeoData() {
  try {
    const response = await fetch('/geo/ip', {
      credentials: 'same-origin'
    });

    if (!response.ok) {
      throw new Error(`IP geolocation failed (${response.status})`);
    }

    return await response.json();
  } catch (error) {
    console.error('IP geolocation error:', error);
    return null;
  }
}

/**
 * Get cookie value by name
 */
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

/**
 * Set cookie with expiration days
 */
function setCookie(name, value, days) {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = [`${name}=${value}`, `expires=${expires.toUTCString()}`, 'path=/'].join(';');
}

/**
 * Update terms link dynamically after detection
 * Reads links from data attributes on the link element
 * (single source of truth)
 */
function updateTermsLink(isSpanish) {
  const termsLinks = document.querySelectorAll('[data-terms-link], [data-privacy-link]');
  if (!termsLinks.length) {
    return;
  }

  termsLinks.forEach(termsLink => {
    const spanishLink = termsLink.dataset.spanishLink;
    const englishLink = termsLink.dataset.englishLink;
    if (spanishLink && englishLink) {
      termsLink.href = isSpanish ? spanishLink : englishLink;
    }
  });
}
